module.exports = __webpack_public_path__ + "img/28.f82a79a9.png";